import { ClickedResultHistory, HistoryState } from '../../../models';
import { HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryMutation } from '../history.interfaces';

export class SetClickedResultHistoryMutation implements HistoryMutation {
  mutations = {
    [HISTORY_MUTATIONS_KEYS.setClickedResultHistory]: (localState: HistoryState, history: ClickedResultHistory) => {
      localState.clickedResultHistory = history;
    }
  };
}
